import React from 'react';

const CancelIcon = ({fill="#229DEC"}) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M7.00004 0.333496C3.31337 0.333496 0.333374 3.3135 0.333374 7.00016C0.333374 10.6868 3.31337 13.6668 7.00004 13.6668C10.6867 13.6668 13.6667 10.6868 13.6667 7.00016C13.6667 3.3135 10.6867 0.333496 7.00004 0.333496ZM10.3334 9.3935L9.39337 10.3335L7.00004 7.94016L4.60671 10.3335L3.66671 9.3935L6.06004 7.00016L3.66671 4.60683L4.60671 3.66683L7.00004 6.06016L9.39337 3.66683L10.3334 4.60683L7.94004 7.00016L10.3334 9.3935Z"
      fill={fill}
    />
  </svg>
);

export default CancelIcon;
